import dayjs from "dayjs";
import jalaliday from "jalaliday";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/fa";

dayjs.extend(relativeTime);

const DateHelper = ({
    datetime,
    format = "DD MMMM YYYY",
    fromNow = false,
}: {
    datetime: string;
    format?: string;
    fromNow?: boolean;
}) => {
    if (!dayjs) {
        return "";
    }

    dayjs.extend(jalaliday);

    dayjs.locale("fa");

    // @ts-ignore
    dayjs.calendar && dayjs.calendar("jalali");

    if (fromNow) {
        // @ts-ignore
        return dayjs(datetime).fromNow();
    } else {
        return dayjs(datetime).format(format);
    }
};

export default DateHelper;
